module.exports = __webpack_public_path__ + "static/happy-97c18394b9de813b1c836fa27aeae85d.svg";